import React from 'react';
import NavBar from '../../components/NavBar';
import { Container } from '../../components/themes';

function NewGroup() {
    return (
        <Container>
            <NavBar />
            <div> new group</div>
        </Container>
    );
}

export default NewGroup;